import {FlexibleStyleProp} from 'common/theme/theme.types';

type TabsBaseStyles = {
    tabpanel?: Record<string, FlexibleStyleProp>;
    tablist?: Record<string, FlexibleStyleProp>;
    tab?: Record<string, FlexibleStyleProp>;
    [key: string]: Record<string, FlexibleStyleProp> | undefined;
};

export const baseStyles: TabsBaseStyles = {
    tabpanel: {
        py: 4,
    },
    tablist: {
        fontSize: 'sm',
    },
    tab: {
        fontSize: 'sm',
        textAlign: 'center',
        transitionProperty: 'common',
        transitionDuration: 'normal',
    },
};
